import type { UpcomingScheduleEntry } from "../../app/services/follows";

/**
 * `upcoming_schedule` から「NG 日 (`status === "off"`)」の日付のみを取り出す。
 *
 * - 並び順は `date` 昇順。元配列がすでに昇順想定 (API 仕様) でもここで再ソートする。
 * - `null` / 空配列入力時は空配列を返す。
 * - `maybe` ステータスはこのヘルパーでは扱わない (オファー作成画面では NG 日のみ表示)。
 */
export const getOffDates = (
  entries: UpcomingScheduleEntry[] | null | undefined,
): string[] => {
  if (!entries?.length) return [];
  return entries
    .filter((e) => e.status === "off")
    .map((e) => e.date)
    .sort();
};
